import { ChangeDetectionStrategy, Component, effect, inject, input, signal } from '@angular/core';
import { UiButtonComponent } from '@big-direkt/ui/button';
import { IconBigMediumChat, IconComponent } from '@big-direkt/utils/icons';
import { ViewMode } from '../enums/view-mode';
import { ChatService } from '../services/chat.service';

@Component({
    selector: 'big-chat-toggle',
    templateUrl: './chat-toggle.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'print:hidden',
        // eslint-disable-next-line @typescript-eslint/naming-convention
        '[class.hidden]': 'config().panel.visible',
    },
    imports: [IconComponent, UiButtonComponent],
})
export class ChatToggleComponent {
    private readonly chatService = inject(ChatService);

    public readonly activeViewMode = signal<ViewMode | undefined>(undefined);
    public readonly config = this.chatService.config;
    public readonly iconChat = IconBigMediumChat;
    public readonly viewMode = input<ViewMode>(ViewMode.chooseChat);
    public readonly viewModeEnum: typeof ViewMode = ViewMode;

    public constructor() {
        effect(() => {
            const viewMode = this.viewMode();
            const activeViewMode = this.activeViewMode();

            if (!activeViewMode) {
                this.activeViewMode.set(viewMode);
            }
        });
    }

    public toggleVisibility(): void {
        this.chatService.toggleVisibility();
    }

    public setViewMode(viewMode: ViewMode): void {
        const config = this.chatService.config();

        if (config.panel.viewMode === this.viewMode() && config.panel.visible !== undefined) {
            this.chatService.setVisibility(false);
            this.chatService.setViewMode(0);

            return;
        }

        this.chatService.setVisibility(true);
        this.chatService.setViewMode(viewMode);
    }
}
